import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
import { Section } from './Section';
import { useLanguage } from './LanguageContext';
export function ProblemList() {
  const {
    t
  } = useLanguage();
  const problems = [t('problemList.prob1'), t('problemList.prob2'), t('problemList.prob3'), t('problemList.prob4')];
  return <Section className="bg-barber-dark border-y border-barber-lightGray" data-id="element-343">
      <div className="max-w-3xl mx-auto" data-id="element-344">
        <div className="mb-12 text-center md:text-left" data-id="element-345">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-barber-text uppercase mb-6" data-id="element-346">
            {t('problemList.heading')}
          </h2>
          <p className="text-xl text-barber-muted mb-4" data-id="element-347">
            {t('problemList.sub1')}
          </p>
          <p className="text-xl text-barber-muted mb-4" data-id="element-348">
            {t('problemList.sub2')}
          </p>
          <p className="text-xl text-barber-muted mb-8" data-id="element-349">
            {t('problemList.sub3')}
          </p>
          <p className="text-2xl text-barber-text font-heading font-bold" data-id="element-350">
            {t('problemList.sub4')}
          </p>
        </div>
        <div className="space-y-4 mb-12" data-id="element-351">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="flex items-center gap-4 bg-barber-black p-5 rounded-sm border border-barber-red/20" data-id="element-352">
              <div className="bg-barber-red/10 p-2 rounded-full shrink-0" data-id="element-353">
                <X className="text-barber-red" size={24} strokeWidth={3} data-id="element-354" />
              </div>
              <p className="text-lg md:text-xl text-barber-text font-medium" data-id="element-355">
                {problem}
              </p>
            </motion.div>)}
        </div>
        <div className="text-center" data-id="element-356">
          <p className="inline-block font-heading text-2xl md:text-3xl text-barber-red font-bold uppercase tracking-wider border-b-2 border-barber-red pb-2" data-id="element-357">
            {t('problemList.closing')}
          </p>
        </div>
      </div>
    </Section>;
}